import Tracker from './Tracker';

const FormSubmitTracker = new Tracker('FormSubmit', {
	REPORTCENTER_LINK: 'reportCenterLink'
});

export default FormSubmitTracker;
